//------------------------------------------------------------------------------
// 地図部品
//------------------------------------------------------------------------------
import React from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import '@arcgis/map-components/components/arcgis-search';
import '@arcgis/map-components/components/arcgis-expand';
import {
  ArcgisSearch,
  ArcgisExpand
} from "@arcgis/map-components-react";
import { setMapConfig } from '@/reducks/setting';

/**
 * 地図検索ボタン (開閉ボタン付き)
 */
export default function MapSearchButton({ slot, ...otherProps }) {

  // 地図動作設定
  const mapConfig = useSelector((state) => state.setting.mapConfig);
  const dispatch = useDispatch();

  // 開閉ボタン処理 - 開閉状態をストアに保存
  const handleExpandSearch = React.useCallback((e) => {
    if (e.detail.name === 'expanded') {
      dispatch(setMapConfig({
        expandSearch: e.target.expanded,
      }));
    }
  }, [mapConfig]);

  //
  // 描画
  //
  return (
    <ArcgisExpand
      slot={slot}
      mode="floating"
      expandTooltip="住所または場所を検索します。"
      expanded={mapConfig.expandSearch}
      onArcgisPropertyChange={handleExpandSearch}
      {...otherProps}
    >
      <ArcgisSearch locationDisabled={true} />
    </ArcgisExpand>
  );
}

// プロパティ
MapSearchButton.propTypes = {
  slot: PropTypes.string,  // スロット
};
